import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { TypographyFontFamily, TypographyFontSize } from '@design-system/components/atoms/typography/entities/typography.types';
import {
  ChipChoiceSize, ChipChoiceState, ChipChoiceType
} from '@design-system/components/molecules/chip-choice/entities/chip-choice.types';
import { Icon, IconFillColor } from '@design-system/components/atoms/icon/entities/icon.types';
import { isEmpty } from '@app/util/util';
import { IconDsComponent } from '@design-system/components/atoms/icon/icon.component';
import { TypographyDsComponent } from '@design-system/components/atoms/typography/typography.component';

@Component({
  selector: 'app-ds-chip-choice',
  templateUrl: './chip-choice.component.html',
  styleUrls: ['./chip-choice.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    IconDsComponent,
    TypographyDsComponent
  ],
})
export class ChipChoiceDsComponent {

  @Input() style = ChipChoiceType.Primary;
  @Input() state = ChipChoiceState.Default;
  @Input() size = ChipChoiceSize.SM;
  @Input() mainText: string;
  @Input() secondaryText: string;
  @Input() icon: Icon;

  @Output() clickEvent: EventEmitter<void> = new EventEmitter<void>();

  constructor() { }

  get fontSize(): typeof TypographyFontSize {
    return TypographyFontSize;
  }

  get fontFamily(): typeof TypographyFontFamily {
    return TypographyFontFamily;
  }

  get showSecondaryText(): boolean {
    return !isEmpty(this.secondaryText) && this.size !== ChipChoiceSize.Minor;
  }

  get iconColor(): IconFillColor {
    switch (this.state) {
      case ChipChoiceState.Default:
      case ChipChoiceState.Active:
        return IconFillColor.Primary;
      case ChipChoiceState.Disabled:
        return IconFillColor.Disabled;
      default:
        return IconFillColor.Primary;
    }
  }

  get iconSize(): number {
    return this.size === ChipChoiceSize.SM ? 16 : 24;
  }

  public clickTrigger(): void {
    if (this.state !== ChipChoiceState.Disabled) {
      this.clickEvent.emit();
    }
  }
}
